<template>
    <div class="mt-2">
        <b-button
            variant="danger"
            @click.stop="abrirModal()"
            :disabled="detalhesSelecionados.length === 0"
        >
            <i class="fa fa-trash mr-2"></i> Excluir em Lote -
            <b-badge variant="light" :style="{ position: 'static' }">
                {{ detalhesSelecionados.length }}
            </b-badge>
        </b-button>
        <b-modal v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Detalhe da Fase -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O que deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group
                            v-model="contratoApostilamento"
                            @change="alternaJustificativa($event)"
                        >
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{ labelJustificativa }}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback>
                            A justificativa {{ textoInfoJustificativa }} é
                            obrigatória
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        detalhesSelecionados: {
            type: Array,
            default: () => []
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        fase: {
            type: Object,
            default: () => {}
        },

        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false,
            obterDetalhesAtualizados: false,
            operacao: 'EXCLUIR EM LOTE',
            erros: [],
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        abrirModal() {
            if (!this.mostrarCheckApostilamento){
                this.confirmarSalvar()
            }else{
                this.mostrarModal = true
            }
        },

        fecharModal() {
            this.mostrarModal = false
            this.reset()
            if (this.obterDetalhesAtualizados) {
                this.$emit('obterDetalhesFaseAtualizados')
                this.$emit('obterComprometimentosAtualizados')
                this.$emit('limparDetalhesSelecionados')
            }
        },

        reset() {
            this.justificativaApostilamento = ''
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterDetalhesAtualizados = false
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Detalhes da Fase',
                html: `Confirma a exclusão dos itens selecionados?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let detalhesExcluidosDto = {
                idContrato: this.$route.params.contratoId,
                faseContratoId: this.fase.faseContratoId,
                detalhesFaseContratoId: this.detalhesSelecionados,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.excluirDetalhesFaseParcelaFixa(
                detalhesExcluidosDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro excluídos com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterDetalhesAtualizados = true
                        this.fecharModal()
                    } else {
                        this.$toast.error(
                            'Erro ao excluir detalhes da fase!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

        verificaTiposAtualizacao() {
            if (
                (this.apostilamento || this.atualizacaoContrato()) &&
                this.contratoApostilamento != null
            ) {
                return true
            } else if (this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-06')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-06')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return this.atualizacaoContrato() && this.apostilamento
        }
    },

    watch: {},

    validations: {
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
